if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.expandShowMore(event);
          const isMobileCollectionFilter = Boolean(
            event.target.closest('.ciw-mobile-vertical-filters')
          );
          if (isMobileCollectionFilter) return;

          const parentDisplay = event.target.closest('.parent-display');
          const nextElementToFocus = parentDisplay?.querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const trigger =
          event.target.closest('[id^="Show-More-"]') ||
          event.target.closest('.button-show-more') ||
          event.target.closest('button');
        const parentDisplay = trigger?.closest('.parent-display');
        if (!parentDisplay) return;

        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
